const PERMISSION_KEY= "crm:tags";
const PAGE_URL = {
    TAGS_PAGE: "/admin/crm/tags"
}

export {PERMISSION_KEY, PAGE_URL}

